<form
  [formGroup]="form"
  class="fpr-import-sheet-form"
  (ngSubmit)="submit()"
  autocomplete="off"
>
  <div class="sheet-header">
    <h2 class="title">{{ translationService.getImportReportDataText() }}</h2>
    <button mat-icon-button type="button" aria-label="Close" (click)="cancel()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-divider></mat-divider>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>Template</mat-label>
    <mat-select formControlName="templateId" required>
      @for (t of templates; track t) {
        <mat-option [value]="t.id">
          {{ t.name }}
        </mat-option>
      }
    </mat-select>
    @if (
      form.get('templateId')?.hasError('required') &&
      form.get('templateId')?.touched
    ) {
      <mat-error>Template is required</mat-error>
    }
  </mat-form-field>

  <div class="file-row">
    <input
      #fileInput
      id="file-upload"
      type="file"
      [accept]="acceptAttr"
      (change)="onFileChange($event)"
      hidden
    />

    <button
      mat-stroked-button
      color="primary"
      type="button"
      (click)="fileInput.click()"
    >
      <mat-icon>upload</mat-icon>
      <span>
        @if (!selectedFile()) {
          Choose File
        }
        @if (selectedFile()) {
          {{ selectedFile()?.name }}
        }
      </span>
    </button>
  </div>

  @if (form.get('file')?.hasError('required') && form.get('file')?.touched) {
    <mat-error>{{ translationService.getFileIsRequiredText() }}</mat-error>
  }
  @if (fileError()) {
    <mat-error>{{ fileError() }}</mat-error>
  }

  @if (showMergeOptions) {
    <mat-divider></mat-divider>

    <section class="merge-options" [formGroup]="form">
      <p class="merge-title">
        {{ translationService.getHowApplyQuantitiesText() }}
      </p>

      <mat-radio-group
        formControlName="mergeMode"
        class="merge-radio-group"
        aria-label="Merge mode"
      >
        <mat-radio-button value="overwrite">
          {{ translationService.getMergeModeOverwriteText() }}
        </mat-radio-button>
        <mat-radio-button value="add">
          {{ translationService.getMergeModeAddText() }}
        </mat-radio-button>
      </mat-radio-group>
    </section>

    <mat-divider></mat-divider>
  }

  <div class="action-buttons">
    <button
      mat-flat-button
      color="primary"
      type="submit"
      [disabled]="form.invalid || !selectedFile()"
    >
      {{ translationService.getSubmitText() }}
    </button>
    <button mat-stroked-button type="button" (click)="reset()">
      {{ translationService.getResetText() }}
    </button>
    <button mat-button type="button" (click)="cancel()">
      {{ translationService.getCancelText() }}
    </button>
  </div>
</form>
